import { createContext, useContext } from 'react';

type LayoutContextType = {
  sidebarCollapsed: boolean;
  sidebarWidth: number;
};

const defaultValue: LayoutContextType = {
  sidebarCollapsed: true,
  sidebarWidth: 60
};

export const LayoutContext = createContext<LayoutContextType>(defaultValue);

export const useLayoutContext = () => useContext(LayoutContext);
